export default __webpack_public_path__ + "static/media/ail1.4e8920e7.svg";